import {
  UserPlanType,
  type UseUserSubscriptionReturnType,
} from './useUserSubscription.types';
import { useUserSubscription as useLegacyUserSubscription } from './useUserSubscription';
import { useUserEntitlementsContext } from '../../context';
import { UserEntitlementsContextType } from '../../context/userEntitlementsContext.types';

export const useUserSubscription = ():
  | UserEntitlementsContextType
  | UseUserSubscriptionReturnType => {
  const entitlementsResult = useUserEntitlementsContext();
  const legacyResult = useLegacyUserSubscription();

  if (
    !entitlementsResult.hasProPlanSubscription &&
    legacyResult.userPlanType === UserPlanType.Clinic
  ) {
    return {
      ...entitlementsResult,
      isUpgradeButtonVisible: false,
      isSubscriptionTabVisible: false,
    };
  }

  return entitlementsResult;
};
